import React, { useContext, useState } from "react";
import { useAxiosPatchRefreshing, useAxiosPostRefreshing } from "../../hooks/useAxios";
import { backend_routes } from "../../common/links";
import MyLoadingIcon from "../UI/loadingIcon/MyLoadingIcon";
import MyButton from "../UI/button/MyButton";
import classes from "./AllForecastModalBody.module.css"
import MySelect from "../UI/select/MySelect";
import { PagesContext } from "../../context/authContext";
import DragDropArea from "../UI/dragDropArea/DragDropArea";
import MyInput from "../UI/input/MyInput";

const AllForecastModalBody = function ({ forecast, closeSelf, modalKind}) {
    let isPost = false;
    if (modalKind==="POST"){
        forecast = {
            theme: "",
            content: "",
            fileUrl: "",
            kind: "day"
        }
        isPost = true;
    }

    const { setPage } = useContext(PagesContext);
    const options =
        [{ value: "day", name: "Дневной прогноз" },
        { value: "month", name: "Месячный прогноз" },
        { value: "year", name: "Годовой прогноз" }];
    const [entityType, setEntityType] = useState("0");
    const [date, setDate] = useState((new Date()).toISOString());
    const [themeValue, setThemeValue] = useState(forecast.theme);
    const [contentValue, setContentValue] = useState(forecast.content);
    const [imgUrl, setImgUrl] = useState(forecast.fileUrl);
    const [files, setFiles] = useState([]);

    const [patchFC, isPatchSending] = useAxiosPatchRefreshing(
        function (response) {
            if (files.length > 0) setImgUrl(response.data.data.fileUrl);
            changeFC();
            closeSelf(false);
        }
    );

    const [postFC, isPostSending] = useAxiosPostRefreshing(
        function () {
            setPage("forecasts_" + entityType);
            closeSelf(false);
        },
        function (badResponse){
            console.log(badResponse);
        }
    );
    
    const changeFC = function(){
        forecast.theme = themeValue;
        forecast.content = contentValue;
        forecast.fileUrl = imgUrl;
    }

    const submit = function () {
        let userData = new FormData();
        userData.set("theme", themeValue);
        userData.set("content", contentValue);

        userData.set("fileCleanup", false);
        if (files.length>0) userData.set("file", files[0]);
        else userData.set("fileCleanup", false);

        if (isPost) postSubmit(userData);
        else patchSubmit(userData);
    }

    const patchSubmit = function(userData){
        userData.set(forecast.kind, forecast.date);
        userData.set("id", forecast.id);
        patchFC(backend_routes.FORECASTS_BASE_PATCH + forecast.kind, userData);
    }

    const postSubmit = function (userData) {
        if (entityType!=="0"){
            userData.set(entityType, date);
            postFC(backend_routes.FORECASTS_BASE_POST + entityType, userData);
        }
    }

    return (
        <>
            {(!isPatchSending || !isPostSending)
                ? <div className={classes.forecastModalBody}>
                    {isPost
                        ? 
                        <>
                            <MySelect options={options} defaultValue={"Тип добавляемой сущности"} value={entityType} onChange={setEntityType} />
                            <input className={classes.inputDate} type="date" onChange={event => {setDate(event.target.value+"T12:34:56Z")}} />
                        </>
                        : <></>
                    }
                    <MyInput placeholder="Тема" type="text" value={themeValue} onChange={(event) => setThemeValue(event.target.value)} />
                    {/* <input /> */}
                    <textarea placeholder="Контент" className={classes.textareaContent} value={contentValue} onChange={(event) => setContentValue(event.target.value)} />
                    {imgUrl === ""
                        ? <></>
                        : <img className={classes.loadedImg} src={imgUrl} alt="Здесь должно быть ваше изображение, но его нет..."/>
                    }

                    <DragDropArea 
                        files={files} 
                        setFiles={setFiles} 
                        fileType={"image/jpeg"}
                        dropAreaCaption={
                            isPost
                            ? "Прикрепить файл"
                            : "Изменить файл"
                        }
                    />

                    <MyButton onClick={() => submit()}>
                        {isPost
                            ? <>Отправить</>
                            : <>Изменить</>
                        }
                    </MyButton>
                </div>
                : <MyLoadingIcon />
            }
        </>
    );
}
export default AllForecastModalBody;